import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./PrizeLocatorDisplayTypeToggle.module.scss";
/**
 * Component used only on tablet and mobile view
 *
 */
export const PrizeLocatorDisplayTypeToggle = ({ mapLabel, listLabel, id, ...rest }) => {
    return (_jsxs("div", { className: styles.prizeLocatorDisplayTypeToggle, children: [_jsx("input", { ...rest, id: id, type: "checkbox", className: styles.input }), _jsxs("label", { className: styles.buttonLabel, htmlFor: id, children: [_jsx("span", { className: `${styles.button} ${styles.mapView}`, children: mapLabel }), _jsx("span", { className: `${styles.button} ${styles.listView}`, children: listLabel })] })] }));
};
//# sourceMappingURL=PrizeLocatorDisplayTypeToggle.js.map